import { Carousel } from 'antd';
import React from 'react';
import { RightOutlined, LeftOutlined } from "@ant-design/icons"

const contentStyle = {
  height: '350px',
  color: '#fff',
  lineHeight: '300px',
  textAlign: 'center',
};
function CarouselMain(){
    return(
      <div className='container'>
        <div className='container-carousel'>
          <Carousel arrows nextArrow={<RightOutlined/>} prevArrow={<LeftOutlined/>} autoplay style={{backgroundImage: "linear-gradient(90deg, #009FB7, #EFF1F3)", width: "700px", height: "400px"}}>
          <div className="container-carousel">
            <div style={contentStyle}> 
            <a href='/category'>
              <img 
                className="brighten"
                alt='Men Sport' 
                src='https://thumbnails.production.thenounproject.com/ysaH2_7ZqYmbeq3AWSLXxr-5dgM=/fit-in/1000x1000/photos.production.thenounproject.com/photos/8CA074AB-BECA-4CC7-B425-5BA4EEFA1F64.jpg'
                style={{width: "100%", height: "auto"}}/>
            </a>         
            </div>
          </div>
          <div className="container-carousel">
            <div style={contentStyle}>
              <img
                alt='Women Sport'
                className="brighten"
                src='https://thumbnails.production.thenounproject.com/lZyq3lKkfEez74Wfz7VFLU-NQPo=/fit-in/1000x1000/photos.production.thenounproject.com/photos/A0FA0829-B8F7-4A89-893A-CB46670CD141.jpg'
                style={{width: "100%", height: "auto"}}/>
            </div>
          </div>
          <div className="container-carousel">
            <div style={contentStyle}>
            <img
                className="brighten"
                alt='Sport People'
                src='https://thumbnails.production.thenounproject.com/GAfT8dS2xgK2Ib9lg6rIokqebuw=/fit-in/1000x1000/photos.production.thenounproject.com/photos/5C8827A2-D47B-45D7-B5C8-35F9EC37E5A9.jpg'
                style={{width: "100%", height: "auto"}}/>
            </div>
          </div>
          </Carousel>
        </div>
      </div>
    )
}

export default CarouselMain